export default "__VITE_ASSET__BAkB5NBM__"